<template> 
  <nt-dialog
    v-model="dialog"
    max-width="480"
    scrollable
  > 
    <div class="contact-agent">
      <!-- <div class="agent-layout">
        <div class="agent-info">
          <img
            width="100%"
            height="100%"
            src="@/assets/contact/support.png"
          />
        </div>
      </div> -->
      <div class="v-card__title py-1 px-0">
        <strong>ช่องทางการติดต่อ</strong>
      </div>
      <a
        v-if="agentInfo.line_id"
        class="my-2 pa-2 rounded-lg card-tile v-card v-card--link v-sheet v-sheet--outlined theme--light elevation-2"
        @click="openLine"
      >
        <div
          class="row no-gutters"
        >
          <div
            class="pa-0 d-flex justify-center align-center col col-3"
          >
            <div
              class="v-image v-responsive pa-1 rounded-lg theme--light"
              style="width: 80px;"
            >
              <img
                width="100%"
                height="100%"
                src="@/assets/contact/line.png"
              />
            </div>
          </div> 
          <hr
            role="separator"
            aria-orientation="vertical"
            class="v-divider v-divider--vertical theme--light"
          > 
          <div
            class="py-0 px-3 d-flex flex-column justify-center col"
          >
            <h4>ติดต่อผ่าน LINE</h4>
            <p
              class="detail-text my-0"
            >
              แอดไลน์ติดต่อ เพื่อขอรับความช่วยเหลือ
            </p>
          </div>
        </div>
      </a>
      <div
        v-if="agentInfo.live_chat_key && isLCAPILoaded"
        class="my-2 pa-2 rounded-lg card-tile v-card v-sheet v-sheet--outlined theme--light elevation-2"
        @click="openLiveChat"
      >
        <div
          class="row no-gutters"
        >
          <div
            class="pa-0 d-flex justify-center align-center col col-3"
          >
            <div
              class="v-image v-responsive pa-1 rounded-lg theme--light"
              style="width: 80px;"
            >
              <img
                width="100%"
                height="100%"
                src="@/assets/contact/live-chat.png"
              />
            </div>
          </div> <hr
            role="separator"
            aria-orientation="vertical"
            class="v-divider v-divider--vertical theme--light"
          > <div
            class="py-0 px-3 d-flex flex-column justify-center col"
          >
            <h4 data-v-cb1e887e="">
              แชทสดกับพนักงาน
            </h4> <p
              data-v-cb1e887e=""
              class="detail-text my-0"
            >
              ติดต่อพนักงาน ผ่านระบบแชทโดยตรง
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="agentInfo.public_phone"
        class="mt-2 pa-2 rounded-lg card-tile v-card v-sheet v-sheet--outlined theme--light elevation-2"
        :onclick="'window.location.href=`tel:' + agentInfo.public_phone + '`'"
      >
        <div
          class="row no-gutters"
        >
          <div
            class="pa-0 d-flex justify-center align-center col col-3"
          >
            <div
              class="v-image v-responsive pa-1 rounded-lg theme--light"
              style="width: 80px;"
            >
              <img
                width="100%"
                height="100%"
                src="@/assets/contact/call.png"
              />
            </div>
          </div> <hr
            role="separator"
            aria-orientation="vertical"
            class="v-divider v-divider--vertical theme--light"
          > <div
            class="py-0 px-3 d-flex flex-column justify-center col"
          >
            <h4 data-v-cb1e887e="">
              โทรด่วนกับพนักงาน
            </h4> 
            <p
              class="detail-text my-0"
            >
              ติดต่อพนักงาน ผ่านการโทรโดยตรง
            </p>
            <p
              class="my-0"
            >
              {{ agentInfo.public_phone }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </nt-dialog>
</template>
<script>
import { news as apiNews } from '@/apis'
import { agentInfo as apiAgentInfo } from '@/apis'    

  export default { 
    data: () => ({
      dialog: false,
      items : [],
      agentInfo: {},
      isLCAPILoaded: false,
    }),
    async created () {
      await this.getAgentInfo()
    },
    mounted () {
      this.checkLCAPI();
    },
    methods : { 
      async open () { 
        await this.GAsidebar()
        this.dialog = true
      },

      async load () {
        let type = { type : 3 } 

        const [err,data ] = await apiNews.getNews(type)  
      
        if(err) { 
          return
        }    

        this.items = data 
      },
      
      async GAsidebar (){ 
        this.$ga.event('Button', 'SelectPage', 'SideBar', 'RuleMain' ) 
        this.load()
      },

      async getAgentInfo (){
        const [err,data ] = await apiAgentInfo.get()
        
        if(err) {
          return
        }     

        this.agentInfo = data 
      },

      openLine () {
        const url = 'http://line.me/ti/p/~' + this.agentInfo.line_id
        window.open(url, "_blank");

        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      },

      openLiveChat () {
        window.LC_API.open_chat_window();

        this.dialog = false
      },

      checkLCAPI () {
        const interval = setInterval(() => {
          if (window.LC_API && typeof window.LC_API.open_chat_window === "function") {
            this.isLCAPILoaded = true;
            clearInterval(interval); 
          }
        }, 500);
      },
    }
  }
</script>
<style scoped>
.contact-agent {
  padding: 1rem;
}

.v-card__title {
  font-size: 20px;
}

.detail-text {
  font-size: 13px;
}

.agent-layout {
  display: flex;
  justify-content: center;
}

.agent-info {
  max-width: 300px;
}

.card-tile:hover {
  color: white !important;
  background-color: var(--bg-main-color);
  cursor: pointer;
}
</style>